import { getRbaPolicy, setRbaPolicy } from '@api/portalServices';
import type { RbaPolicyGetResponse, RbaPolicySetRequest } from '@api/types';
import { useSession } from '@common/authorization/context/Session';
import type { ApiError } from '@errorHandler/errors';
import { QueryKey } from '@portal/constants';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useRbaPolicyQuery = ({ enabled }: { enabled: boolean }) => {
  const { tenantId } = useSession();

  return useQuery<RbaPolicyGetResponse, ApiError>({
    queryKey: [QueryKey.RBA_POLICY, tenantId],
    queryFn: () => getRbaPolicy(),
    enabled: enabled && Boolean(tenantId),
    retry: false,
    staleTime: 0,
  });
};

export const useRbaPolicyMutation = () => {
  const queryClient = useQueryClient();
  const { tenantId } = useSession();

  return useMutation<unknown, ApiError, RbaPolicySetRequest>({
    mutationFn: request => setRbaPolicy(request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.RBA_POLICY, tenantId] }),
    retry: false,
  });
};
